/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMigrationStatus } from './UserMigrationStatus';
import {
    UserMigrationStatusFromJSON,
    UserMigrationStatusFromJSONTyped,
    UserMigrationStatusToJSON,
    UserMigrationStatusToJSONTyped,
} from './UserMigrationStatus';

/**
 * 
 * @export
 * @interface UserMigrationStatusResponse
 */
export interface UserMigrationStatusResponse {
    /**
     * 
     * @type {UserMigrationStatus}
     * @memberof UserMigrationStatusResponse
     */
    migrationStatus?: UserMigrationStatus;
}



/**
 * Check if a given object implements the UserMigrationStatusResponse interface.
 */
export function instanceOfUserMigrationStatusResponse(value: object): value is UserMigrationStatusResponse {
    return true;
}

export function UserMigrationStatusResponseFromJSON(json: any): UserMigrationStatusResponse {
    return UserMigrationStatusResponseFromJSONTyped(json, false);
}

export function UserMigrationStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'migrationStatus': json['migrationStatus'] == null ? undefined : UserMigrationStatusFromJSON(json['migrationStatus']),
    };
}

export function UserMigrationStatusResponseToJSON(json: any): UserMigrationStatusResponse {
    return UserMigrationStatusResponseToJSONTyped(json, false);
}

export function UserMigrationStatusResponseToJSONTyped(value?: UserMigrationStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'migrationStatus': UserMigrationStatusToJSON(value['migrationStatus']),
    };
}

